import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "dropdown_hint body-font-s"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "select-wrapper" }
const _hoisted_5 = ["id", "name", "value"]
const _hoisted_6 = {
  key: 0,
  value: ""
}
const _hoisted_7 = ["value"]


import { DropdownValue } from '../../types';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    inputKey: null,
    title: null,
    options: null,
    translateTitle: { type: Boolean },
    allowAll: { type: Boolean },
    hint: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      class: "f-w-b",
      for: __props.inputKey
    }, [
      _createTextVNode(_toDisplayString(__props.title), 1),
      (__props.hint)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(_toDisplayString(__props.hint), 1)
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("select", {
          id: __props.inputKey,
          name: __props.inputKey,
          value: __props.modelValue,
          class: "dropdown-select",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue',
  ($event.target as HTMLInputElement).value)))
        }, [
          (__props.allowAll)
            ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(_ctx.$t('dropdownAll')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.id,
              value: option.id
            }, _toDisplayString(__props.translateTitle ? _ctx.$t(option.title) : option.title), 9, _hoisted_7))
          }), 128))
        ], 40, _hoisted_5)
      ])
    ])
  ], 64))
}
}

})